import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import {Constants} from '../../constants';
import {DataManagementService} from '../../services/data-management.service';
import {Router} from '@angular/router';
import {AppSettings} from '../../../app-settings';
import {AccessService} from '../../services/access.service';

@Component({
    selector: 'app-incoming-term-schedule',
    templateUrl: './incoming-term-schedule.component.html',
    styleUrls: ['./incoming-term-schedule.component.css']
})
export class IncomingTermScheduleComponent implements OnInit {
    @ViewChild('addEditIncomingTermModal') addEditIncomingTermModal: TemplateRef<any>;
    @ViewChild('universitiesModal') universitiesModal: TemplateRef<any>;
    downloadPocPasswords = AppSettings.DOWNLOAD_POC_PASSWORDS;
    public modalReference: NgbModalRef;
    incomingTerms;
    errorMessage;
    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    newTerm;
    academicYear;
    universities;
    universitiesErrorMessage;
    checkedUniversities = [];
    universitiesBackupObject = {};
    editIncomingTermFlag;
    selectUndefinedOptionValue;

    constructor(private modal: NgbModal,
                private dmService: DataManagementService,
                private router: Router,
                private accessService: AccessService) {
    }

    getIncomingTerms(): void {
        this.dmService.javaGetDataCall(Constants.INCOMING_TERM_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.incomingTerms = response.data.incoming_terms;
                        this.academicYear = response.data.academic_year;
                        if (this.incomingTerms.length <= 0) {
                            this.errorMessage = 'There is no data available for incoming terms';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message') && response.message !== null) {
                            this.errorMessage = response.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    openAddIncomingTermModal(): void {
        this.dmService.javaGetDataCall(Constants.ADD_INCOMING_TERM_SETTINGS).subscribe(responseData => {
                if (responseData.status === 'success') {
                    this.universities = responseData.data;
                    if (this.universities.length === 0) {
                        this.universitiesErrorMessage = 'There is no data available for universities.';
                    }
                } else if (responseData.status === 'fail') {
                    if (responseData.data.hasOwnProperty('message')) {
                        this.universitiesErrorMessage = responseData.data.message;
                    } else {
                        this.universitiesErrorMessage = 'Something went wrong. Please contact support team';
                    }
                }
            },
            error => {
                console.log(error);
                this.universitiesErrorMessage = 'Server Error';
            });
        this.modalReference = this.modal.open(this.universitiesModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    saveUniversities(): void {
        this.modalReference.close();
        this.modalReference = this.modal.open(this.addEditIncomingTermModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    backToUniversities(): void {
        this.modalReference.close();
        this.modalReference = this.modal.open(this.universitiesModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    clearUniversities(): void {
        for (let i = 0; i < this.universities.length; i++) {
            for (let j = 0; j < this.checkedUniversities.length; j++) {
                if (this.checkedUniversities[j].university_id === this.universities[i].university_id) {
                    delete this.universitiesBackupObject[this.checkedUniversities[j].university_id];
                    this.checkedUniversities.splice(this.checkedUniversities.indexOf(this.checkedUniversities[j]), 1);
                }
            }
        }
    }

    selectUniversities(): void {
        this.clearUniversities();
        for (let i = 0; i < this.universities.length; i++) {
            this.universitiesBackupObject[this.universities[i].university_id] = true;
            this.checkedUniversities.push({
                'university_id': this.universities[i].university_id,
                'university_name': this.universities[i].university_name,
            });
        }
    }

    toggleUniversity(isChecked, university: any) {
        if (isChecked === true) {
            this.universitiesBackupObject[university.university_id] = true;
            this.checkedUniversities.push({
                'university_id': university.university_id,
                'university_name': university.university_name
            });
        } else {
            for (let i = 0; i < this.checkedUniversities.length; i++) {
                if (this.checkedUniversities[i].university_id === university.university_id) {
                    delete this.universitiesBackupObject[this.checkedUniversities[i].university_id];
                    this.checkedUniversities.splice(this.checkedUniversities.indexOf(this.checkedUniversities[i]), 1);
                }
            }
        }
    }


    sendLoginDetailsToPOC(incoming_term_id): void {
        const that = this;
        let sendNominationResponse;
        const obj = {
            incoming_term_id: incoming_term_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        console.log(obj);
        Swal({
            title: 'Confirm',
            type: 'question',
            text: 'Do you want to send login details to selected universities POC through email?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(obj, Constants.LOGIN_DETAILS_TO_POC).subscribe(resData => {
                        sendNominationResponse = resData;
                        resolve(sendNominationResponse);
                    }, error => {
                        sendNominationResponse = error;
                        reject(sendNominationResponse);
                    });
                });
            },
            allowOutsideClick: false,
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (sendNominationResponse.status === 'success') {
                    Swal({
                        title: 'Success',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Successfully send login details to selected universities POC.</p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (sendNominationResponse.status === 'fail') {
                    if (sendNominationResponse.message !== 'null') {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to send login details to selected universities POC, '
                                + sendNominationResponse.message + '</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to send login details to selected universities POC, Please contact support team.</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    openEditIncomingTermModal(incomingTerm): void {
        this.editIncomingTermFlag = true;
        this.newTerm = incomingTerm;
        this.newTerm.nomination_start_date = this.getDateTimeForForm(this.newTerm.nomination_start_date);
        this.newTerm.nomination_end_date = this.getDateTimeForForm(this.newTerm.nomination_end_date);
        this.newTerm.registration_start_date = this.getDateTimeForForm(this.newTerm.registration_start_date);
        this.newTerm.registration_end_date = this.getDateTimeForForm(this.newTerm.registration_end_date);
        this.dmService.javaGetDataCallByParameter(Constants.EDIT_INCOMING_TERM_SETTINGS, incomingTerm.incoming_term_id)
            .subscribe(responseData => {
                    if (responseData.status === 'success') {
                        this.universities = responseData.data.all_universities;
                        this.checkedUniversities = responseData.data.term_universities;
                        if (this.universities.length === 0) {
                            this.universitiesErrorMessage = 'There is no data available for universities.';
                        }
                        for (let i = 0; i < this.checkedUniversities.length; i++) {
                            this.universitiesBackupObject[this.checkedUniversities[i].university_id] = true;
                        }
                    } else if (responseData.status === 'fail') {
                        if (responseData.data.hasOwnProperty('message')) {
                            this.universitiesErrorMessage = responseData.data.message;
                        } else {
                            this.universitiesErrorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.universitiesErrorMessage = 'Server Error';
                });
        this.modalReference = this.modal.open(this.universitiesModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    addEditIncomingTerm(): void {
        if (this.editIncomingTermFlag === true) {
            this.editIncomingTerm();
        } else {
            this.addIncomingTerm();
        }
    }

    addIncomingTerm(): void {
        const that = this;
        let addTermSettingResponse;
        const universityIdsArray = [];
        for (let i = 0; i < this.checkedUniversities.length; i++) {
            universityIdsArray.push(this.checkedUniversities[i].university_id);
        }
        console.log(universityIdsArray);
        const data = {
            incoming_term: this.newTerm,
            universities: universityIdsArray,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        Swal({
            title: 'confirm',
            type: 'question',
            text: 'Do you want to add this incoming term?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                that.newTerm.nomination_start_date = that.getDateTimeToSend(that.newTerm.nomination_start_date);
                that.newTerm.nomination_end_date = that.getDateTimeToSend(that.newTerm.nomination_end_date);
                that.newTerm.registration_start_date = that.getDateTimeToSend(that.newTerm.registration_start_date);
                that.newTerm.registration_end_date = that.getDateTimeToSend(that.newTerm.registration_end_date);
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(data, Constants.INCOMING_TERM_SETTINGS).subscribe(resData => {
                        addTermSettingResponse = resData;
                        resolve(addTermSettingResponse);
                    }, error => {
                        addTermSettingResponse = error;
                        reject(addTermSettingResponse);
                    });
                });
            },
            allowOutsideClick: false,
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (addTermSettingResponse.status === 'success') {
                    that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
                        that.router.navigate(['term-schedule/incoming']));
                    Swal({
                        title: 'Success',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Incoming Term Settings Added successfully.</p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                    that.closeModal();
                } else if (addTermSettingResponse.status === 'fail') {
                    that.newTerm.nomination_start_date = that.getDateTimeForForm(that.newTerm.nomination_start_date);
                    that.newTerm.nomination_end_date = that.getDateTimeForForm(that.newTerm.nomination_end_date);
                    that.newTerm.registration_start_date = that.getDateTimeForForm(that.newTerm.registration_start_date);
                    that.newTerm.registration_end_date = that.getDateTimeForForm(that.newTerm.registration_end_date);
                    if (addTermSettingResponse.message !== 'null') {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to add  Term Settings, ' + addTermSettingResponse.message + '</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to add  Term Settings, Please contact support team.</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    editIncomingTerm(): void {
        const that = this;
        let editTermSettingResponse;
        const universityIdsArray = [];
        for (let i = 0; i < this.checkedUniversities.length; i++) {
            universityIdsArray.push(this.checkedUniversities[i].university_id);
        }
        console.log(universityIdsArray);
        const data = {
            incoming_term: this.newTerm,
            universities: universityIdsArray,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        Swal({
            title: 'confirm',
            type: 'question',
            text: 'Do you want to edit this incoming term?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                that.newTerm.nomination_start_date = that.getDateTimeToSend(that.newTerm.nomination_start_date);
                that.newTerm.nomination_end_date = that.getDateTimeToSend(that.newTerm.nomination_end_date);
                that.newTerm.registration_start_date = that.getDateTimeToSend(that.newTerm.registration_start_date);
                that.newTerm.registration_end_date = that.getDateTimeToSend(that.newTerm.registration_end_date);
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(data, Constants.INCOMING_TERM_SETTINGS).subscribe(resData => {
                        editTermSettingResponse = resData;
                        resolve(editTermSettingResponse);
                    }, error => {
                        editTermSettingResponse = error;
                        reject(editTermSettingResponse);
                    });
                });
            },
            allowOutsideClick: false,
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (editTermSettingResponse.status === 'success') {
                    that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
                        that.router.navigate(['term-schedule/incoming']));
                    Swal({
                        title: 'Success',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Incoming Term Settings Modified successfully.</p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                    that.closeModal();
                } else if (editTermSettingResponse.status === 'fail') {
                    that.newTerm.nomination_start_date = that.getDateTimeForForm(that.newTerm.nomination_start_date);
                    that.newTerm.nomination_end_date = that.getDateTimeForForm(that.newTerm.nomination_end_date);
                    that.newTerm.registration_start_date = that.getDateTimeForForm(that.newTerm.registration_start_date);
                    that.newTerm.registration_end_date = that.getDateTimeForForm(that.newTerm.registration_end_date);
                    if (editTermSettingResponse.message !== 'null') {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to Modify Term Settings, ' + editTermSettingResponse.message + '</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to Modify Term Settings, Please contact support team.</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    clearIncomingTerms(): void {
        const that = this;
        Swal({
            title: 'confirm',
            type: 'question',
            text: 'Do you want to clear all incomingTermSchedule?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    localStorage.setItem('incomingTerms', '[]');
                    resolve(true);
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.value === true) {
                that.getIncomingTerms();
                Swal({
                    title: 'Success',
                    type: 'success',
                    width: 600,
                    padding: 80,
                    showCancelButton: false,
                    showConfirmButton: true,
                    html: '<p>Successfully cleared the incomingTermSchedule.</p>',
                });
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    deleteIncomingTerm(incomingTerm): void {
        const that = this;
        let deleteTermResponse;
        Swal({
            title: 'confirm',
            type: 'question',
            html: 'Do you want to delete <span class="font-weight-bold">' +
                incomingTerm.incoming_term_name + '</span> incoming term-settings?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(incomingTerm, Constants.DELETE_INCOMING_TERM_SETTINGS).subscribe(data => {
                        deleteTermResponse = data;
                        resolve(deleteTermResponse);
                    }, error => {
                        deleteTermResponse = error;
                        reject(deleteTermResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (deleteTermResponse.status === 'success') {
                    that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
                        that.router.navigate(['/term-schedule/incoming']));
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Successfully deleted the '
                            + '<span class="font-weight-bold">' + incomingTerm.incoming_term_name + '</span> term settings.</p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (deleteTermResponse.status === 'fail') {
                    if (deleteTermResponse.message !== 'null') {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to Delete <span class="font-weight-bold">'
                                    + incomingTerm.incoming_term_name + '</span> Term Settings, ' + deleteTermResponse.message + '</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Unable to Delete <span class="font-weight-bold">'
                                    + incomingTerm.incoming_term_name + '</span> Term Settings.</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    getDateTime(dateTime): string {
        if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
            return '';
        }
        return moment(dateTime).format('Do MMM YYYY , hh:mm a');
    }

    getDateTimeForForm(dateTime): string {
        if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
            return '';
        }
        return moment(dateTime).format('YYYY-MM-DDTHH:mm');
    }

    getDateTimeToSend(dateTime): string {
        if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
            return '';
        }
        return moment(dateTime).format('YYYY-MM-DD HH:mm');
    }

    closeModal(): void {
        this.editIncomingTermFlag = false;
        this.newTerm = {};
        this.universitiesBackupObject = {};
        this.universities = [];
        this.checkedUniversities = [];
        this.universitiesErrorMessage = undefined;
        this.modalReference.close();
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessEC() {
        return this.accessService.canAccessEC();
    }

    ngOnInit() {
        this.newTerm = {};
        this.getIncomingTerms();
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
    }

}
